import React from "react";
import Page from "../../shared/components/Page";
import ChapterLoader from "./ChapterLoader";

export enum Chapter {
  "Introduction" = "introduction",
  "Chapter1" = "chapter1",
  "Chapter2" = "chapter2",
  "Chapter3" = "chapter3",
}

const chapterTitles = {
  [Chapter.Introduction]: "Introduction",
  [Chapter.Chapter1]: "Chapter 1",
  [Chapter.Chapter2]: "Chapter 2",
  [Chapter.Chapter3]: "Chapter 3",
};

interface BookChapterProps {
  chapter: Chapter;
}

function BookChapter(props: BookChapterProps) {
  return (
    <Page title={chapterTitles[props.chapter]}>
      <ChapterLoader chapter={props.chapter} />
    </Page>
  );
}

export default BookChapter;
